// NavbarLinks.js

import React from "react"
import { Link } from "gatsby"
import { css } from "@emotion/core"


const ListLink = props => (
    <li style={{ display: `inline-block`, marginRight: `1rem`}}><h4
    css={css`
            @media (max-width: 811px) {
              font-size:80%;
            }
          `}
          >
      <Link to={props.to}>{props.children}</Link></h4>
    </li>
  )

const NavbarLinks = () => {
  return (
    // <>
    //   <Link to="/">About</Link>
    //   <Link to="/404">Services</Link>
    //   <Link to="/">Gallery</Link>
    //   <Link to="/404">Contact</Link>
    // </>
<>
    <ListLink to="/">About</ListLink>
    <ListLink to="/writing/">Writing</ListLink>
    <li style={{ display: `inline-block`, marginRight: `1rem` }}><h4
    css={css`
    @media (max-width: 811px) {
      font-size:80%;
    }
  `}><a href="https://truecolors.substack.com/" target="_blank" rel="noopener noreferrer">Newsletter</a></h4>
  </li>
  <ListLink to="/contact/">Contact</ListLink>
        </>
  )
}

export default NavbarLinks